import { env } from '@/lib/env';

export function redirectToLogin(urlToReturn?: string) {
  const currentUrl = window.location.href;
  window.location.replace(`${env('NAVER_LOGIN')}?mode=form&url=${encodeURIComponent(urlToReturn || currentUrl)}`);
}
